import { CopyAgentsModel } from './../../shared/Models/OldWekalaModel';

import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators';
import CopyClauseModel from '@/shared/Models/CopyClauseModel';
import CopyWekalaDetailsServiceModel from '@/shared/Models/CopyWekalaDetailsServiceModel';
import { CopyWekalaTypeEnum } from '@/components/AttorneyRegistration/Component/Enums/CopyWekalaTypeEnum';
import { ClauseResponse } from '@/components/AttorneyRegistration/Component/Models/ClauseResponse';

//@Module({ namespaced: true })
@Module({})
export default class CopyWekalaStore extends VuexModule {
  copyAgents: CopyAgentsModel[] = [];
  copyClauses: CopyClauseModel[] = [];
  copyWekalaCode: number = 0;
  copyWekalaNationalId: string = '';
  containProhiptedClauses: boolean = false;
  copyWekalaID: number = 0;
  copyType: CopyWekalaTypeEnum | undefined = undefined;
  copiedmessage: string = '';
  flatenAgencyTermsToStore: ClauseResponse[] = [];

  //Getters
  get getCopyAgents(): CopyAgentsModel[] {
    return this.copyAgents;
  }

  get getflatenAgencyTermsToStore(): ClauseResponse[] {
    return this.flatenAgencyTermsToStore;
  }

  get getcopiedmessage(): string {
    return this.copiedmessage;
  }

  get getCopyClauses(): CopyClauseModel[] {
    return this.copyClauses;
  }

  get getCopyWekalaID(): number {
    return this.copyWekalaID;
  }

  get getCopyWekalaCode(): number {
    return this.copyWekalaCode;
  }

  get getCopyWekalaNationalId(): string {
    return this.copyWekalaNationalId;
  }

  get getCopyType(): CopyWekalaTypeEnum | undefined {
    return this.copyType;
  }

  get DoescontainProhiptedClauses(): boolean {
    return this.containProhiptedClauses;
  }

  //Mutations
  @Mutation
  public setCopyAgentsMutation(agents: CopyAgentsModel[]): void {
    this.copyAgents = agents;
  }

  @Mutation
  public setflatenAgencyTermsToStoreMut(clauses: ClauseResponse[]): void {
    this.flatenAgencyTermsToStore = clauses;
  }

  @Mutation
  public setcopiedmessageMutation(message: string): void {
    this.copiedmessage = message;
  }

  @Mutation
  public setCopyTypeMutation(ctype: CopyWekalaTypeEnum): void {
    this.copyType = ctype;
  }

  @Mutation
  public setCopyClausesMutation(clauses: CopyClauseModel[]): void {
    this.copyClauses = clauses;
  }

  @Mutation
  public setCopyWekalaIDMutation(wekalaID: number): void {
    this.copyWekalaID = wekalaID;
  }

  @Mutation
  public setCopyWekalaCodeMutation(wekalaCode: number): void {
    this.copyWekalaCode = wekalaCode;
  }

  @Mutation
  public setCopyWekalaNationalIdMutation(nationalId: string): void {
    this.copyWekalaNationalId = nationalId;
  }

  @Mutation
  public setCopyWekalaContainProhiptedClausesMutation(val: boolean): void {
    this.containProhiptedClauses = val;
  }
  //Actions
  @Action
  public setCopyAgentsAction(agents: CopyAgentsModel[]): void {
    this.context.commit('setCopyAgentsMutation', agents);
    this.context.commit(
      'setCopyTypeMutation',
      CopyWekalaTypeEnum.CopyWekalaSecondParties
    );
  }

  @Action
  public clearCopyAgentsAction(): void {
    this.context.commit('setCopyAgentsMutation', []);
  }

  @Action
  public SetcopiedmessageAction(message: string): void {
    this.context.commit('setcopiedmessageMutation', message);
  }

  @Action
  public setCopyClausesAction(copyWek: CopyWekalaDetailsServiceModel): void {
    this.context.commit('setCopyClausesMutation', copyWek.flatenAgencyTerms);
    this.context.commit(
      'setflatenAgencyTermsToStoreMut',
      copyWek.flatenAgencyTermsToStore
    );
    this.context.commit('setCopyWekalaIDMutation', copyWek.wekalaId);
    this.context.commit('setCopyWekalaCodeMutation', copyWek.number);
    this.context.commit('setCopyWekalaNationalIdMutation', copyWek.nationalId);
    this.context.commit(
      'setCopyWekalaContainProhiptedClausesMutation',
      copyWek.containProhiptedClauses
    );
    this.context.commit(
      'setCopyTypeMutation',
      CopyWekalaTypeEnum.CopyWekalaClauses
    );
  }

  @Action
  public setCopywekalaCodeAction(wekalaCode: number): void {
    this.context.commit('setCopyWekalaCodeMutation', wekalaCode);
  }

  @Action
  public setCopywekalaIdAction(wekalaId: number): void {
    this.context.commit('setCopyWekalaIDMutation', wekalaId);
  }

  @Action
  public clearCopyClausesAction(): void {
    this.context.commit('setCopyClausesMutation', []);
    this.context.commit('setCopyWekalaIDMutation', 0);
    this.context.commit('setCopyWekalaCodeMutation', 0);
    this.context.commit('setCopyWekalaNationalIdMutation', '');
    this.context.commit('setCopyWekalaContainProhiptedClausesMutation', false);
  }
}
